import { Subtitle2, Title1, Title3, makeStyles, mergeClasses, tokens } from "@fluentui/react-components";
import type { ComponentProps } from "react";

const useStyles = makeStyles({
  regular: {
    fontWeight: tokens.fontWeightRegular,
  },
  pageHeader: {
    fontWeight: tokens.fontWeightRegular,
    fontSize: tokens.fontSizeBase400,
    lineHeight: tokens.lineHeightBase400,
  },
  /** 목록 화면 제목. 필터 줄 위, 20px. */
  pageHeaderLarge: {
    fontWeight: tokens.fontWeightRegular,
    fontSize: tokens.fontSizeBase500,
    lineHeight: tokens.lineHeightBase500,
  },
});

/** 페이지 상단 바 제목. page는 16px, large는 목록 제목 20px. 모두 Regular. */
export function PageHeaderTitle({ className, size = "page", ...props }: ComponentProps<typeof Title3> & { size?: "page" | "large" }) {
  const styles = useStyles();
  return <Title3 className={mergeClasses(size === "large" ? styles.pageHeaderLarge : styles.pageHeader, className)} {...props} />;
}

/** 페이지 내 섹션·그룹 제목 (Subtitle2 · Regular) */
export function SectionTitle({ className, ...props }: ComponentProps<typeof Subtitle2>) {
  const styles = useStyles();
  return <Subtitle2 className={mergeClasses(styles.regular, className)} {...props} />;
}

/** 카드 헤더·타일 제목 (SectionTitle과 동일 위계) */
export const CardTitle = SectionTitle;

/** 프로젝트명·큰 숫자 등 Display (Title1 · Regular) */
export function DisplayTitle({ className, ...props }: ComponentProps<typeof Title1>) {
  const styles = useStyles();
  return <Title1 className={mergeClasses(styles.regular, className)} {...props} />;
}

/** 강조 수치·금액 (Title3 크기 · Regular, 색은 호출부) */
export function EmphasisValue({ className, ...props }: ComponentProps<typeof Title3>) {
  const styles = useStyles();
  return <Title3 className={mergeClasses(styles.regular, className)} {...props} />;
}
